
/**
 * Note:
 * <dialog> 要素の利用推奨
 * polyfill: <https://github.com/GoogleChrome/dialog-polyfill>
 */
var Common = Common || {};

// グローバル変数に代入
window.Common = Common;

/** modal **/

// モジュール名
Common.Modal = Common.Modal || {};

//追加(CTC)---------------------------------------------------↓
/**
 * ダイアログ呼び出し元を保持するクラスプロパティ
 */
Common.Modal.opener = null;

/**
 * ダイアログ呼び出し時に呼び出し元のイベントタイプを保持するクラスプロパティ
 */
Common.Modal.openerEventType = null;
//------------------------------------------------------------↑

// コンストラクター
Common.Modal = function (configurations) {
  'use strict';
  var _this = this;
};

// 定数
Common.Modal.CONSTANT = {
  openBtn: '.js-modal-open',
  closeBtn: '.js-modal-close',
  modalWrapper: '.js-modal',
};


// 初期化
Common.Modal.prototype.init = function () {
  'use strict';
  var _this = this;


  // イベントのアタッチ
  _this.attachEvent();

};


// リサイズ
Common.Modal.prototype.reizeModalUpdate = function () {
  'use strict';
  var _this = this;

  $(Common.Modal.CONSTANT.modalWrapper).each(function () {
    // SP表示の場合
    if (window.matchMedia("screen and (max-width:768px)").matches) {
      // 指定されたwidthを削除する
      $(this).find('.p-modal').css('width', '');
    }
    else {
      if (!window.matchMedia("screen and (max-width:768px)").matches && $(this).attr('data-modal-width') != void 0 || !window.matchMedia("screen and (max-width:768px)").matches && $(this).attr('data-modal-width') != '') {
        $(this).find('.p-modal').css({
          width: $(this).attr('data-modal-width')
        });
      }
    }
    _this.modalTopPositionSet($(this).find('.p-modal'))
  });
};

// モーダルクローズ
Common.Modal.prototype.modalClose = function (target) {
  'use strict';
  var _this = this;

  target.closest(Common.Modal.CONSTANT.modalWrapper).hide();


  // SP表示の場合
  if (window.matchMedia("screen and (max-width:768px)").matches) {
    $('body, html').css({
      overflow: '',
      height: ''
    });

    $('.l-container').css({
      position: 'static',
      top: '0',
      width: ''
    });
  }
  else {

    $('body, html').css({
      overflow: '',
    });
  }

  $('html,body').scrollTop(_this.scrollTop);

}

// モーダルクローズ
Common.Modal.prototype.modalTopPositionSet = function (target) {
  'use strict';
  var _this = this;

  // モーダルの坂を設定
  var winHeight = window.innerHeight;
  var menuHeight = target.outerHeight(true);
  var diffHeight = (winHeight - menuHeight) / 2;

  if (diffHeight < 0) {
    target.css({
      top: '',
    });
  }
  else {
    target.css({
      top: diffHeight + 'px',
    });
  }

}


// モーダルオープン
Common.Modal.prototype.modalOpen = function (id, e) {
  'use strict';
  var _this = this;

  var modalSize = $('#' + id).attr('data-modal-width');
  $('#' + id).show();

  _this.scrollTop = $(window).scrollTop();

  // SP表示の場合
  if (window.matchMedia("screen and (max-width:768px)").matches) {

    $('body, html').css({
      overflow: 'hidden',
      height: '100%'
    });

    $('.l-container').css({
      position: 'fixed',
      top: -_this.scrollTop
    });
  }
  else {

    $('body, html').css({
      overflow: 'hidden',
    });

  }


  // PC 版だった場合
  if (!window.matchMedia("screen and (max-width:768px)").matches && modalSize != void 0 || !window.matchMedia("screen and (max-width:768px)").matches && modalSize != '') {
    $('#' + id).find('.p-modal').css({
      width: modalSize,
    });
  }

  _this.modalTopPositionSet($('#' + id).find('.p-modal'));

}

// 初期化
Common.Modal.prototype.attachEvent = function () {
  'use strict';
  var _this = this;

  $(Common.Modal.CONSTANT.openBtn).on('click', function (event) {
    event.preventDefault();
    _this.modalOpen($(this).attr('data-id'));
  });


  $(Common.Modal.CONSTANT.closeBtn).on('click', function (event) {
    event.preventDefault();
    _this.modalClose($(this));
  });

  // windowをリサイズ
  var resizeTimer = false;
  $(window).on('resize', function () {
    if (resizeTimer !== false) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function () {
      _this.reizeModalUpdate();
    }, 200);
  });

}


// 実行
$(function () {
  'use strict';

  // モーダルの初期実行
  var modal = new Common.Modal();
  modal.init();

});
